module.exports = __webpack_public_path__ + "img/card-product-placeholder-spi.svg";